import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from 'vanilla-cookieconsent';
import { initGA } from './analytics';

// Compact styling via CSS variables
const compactStyles = `
:root {
  --cc-font-family: inherit;
  --cc-modal-border-radius: 0.375rem;
  --cc-btn-border-radius: 0.25rem;
  --cc-modal-margin: 0.75rem;
}
#cc-main {
  font-size: 14px;
}
#cc-main .cm {
  max-width: 320px;
}
#cc-main .cm__desc {
  font-size: 0.8125em;
}
#cc-main .cm__btn {
  font-size: 0.75em;
  padding: 0.6em 1em;
  min-height: 36px;
}
#cc-main .cm__texts {
  padding: 0.875rem 1rem !important;
}
#cc-main .cm__btns {
  padding: 0.75rem 1rem !important;
}
`;

export function initCookieConsent() {
  // Inject compact styles
  const style = document.createElement('style');
  style.textContent = compactStyles;
  document.head.appendChild(style);

  CookieConsent.run({
    guiOptions: {
      consentModal: {
        layout: 'box inline',
        position: 'bottom left',
        equalWeightButtons: true,
      },
    },
    categories: {
      necessary: {
        enabled: true,
        readOnly: true,
      },
      analytics: {
        enabled: false,
        autoClear: {
          cookies: [{ name: /^_ga/ }],
        },
      },
    },
    language: {
      default: 'es',
      translations: {
        es: {
          consentModal: {
            title: 'Usamos cookies',
            description: 'Utilizamos cookies para analizar el tráfico y mejorar tu experiencia.',
            acceptAllBtn: 'Aceptar',
            acceptNecessaryBtn: 'Rechazar',
            showPreferencesBtn: 'Ajustes',
          },
          preferencesModal: {
            title: 'Preferencias de cookies',
            acceptAllBtn: 'Aceptar todas',
            acceptNecessaryBtn: 'Rechazar todas',
            savePreferencesBtn: 'Guardar',
            sections: [
              {
                title: 'Cookies necesarias',
                description: 'Esenciales para el funcionamiento del sitio.',
                linkedCategory: 'necessary',
              },
              {
                title: 'Cookies de análisis',
                description: 'Nos ayudan a entender cómo usas el sitio.',
                linkedCategory: 'analytics',
              },
            ],
          },
        },
      },
    },
    onConsent: ({ cookie }) => {
      if (cookie.categories.includes('analytics')) {
        initGA();
      }
    },
    onChange: ({ cookie }) => {
      if (cookie.categories.includes('analytics')) {
        initGA();
      }
    },
  });
}
